import React, { useState, useEffect } from 'react';
import './XR.css';
import Navbar from '../components/Navbar';

const ForAcademia = () => {
  const [showMore, setShowMore] = useState({
    awareness: false,
    labs: false,
    content: false,
    environments: false,
    innovation: false,
  });
  
    useEffect(() => {
      window.scrollTo(0, 0); 
    }, []);
  const toggleShowMore = (key) => {
    setShowMore((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const sections = [
    {
      key: 'awareness',
      title: 'XR Awareness & Faculty Development',
      subtitle:'Empowering Educators to Lead in the XR Era',
      description: `Empowering educators with XR knowledge and hands-on exposure to drive innovation in teaching 
and academic research. These programs are designed to upskill faculty members, helping them inte
grate immersive technologies into pedagogy and curriculum.`,
      highlights: [
        'Foundational workshops on XR principles, applications, and industry trends',
        'Hands-on sessions with VR/AR hardware and educational XR tools',
        'Custom programs for curriculum integration and interdisciplinary projects',
        'Support for academic innovation, proposal writing, and research planning ',
      ],
      image: '../images/XR workshop_l.webp',
      alt: 'XR Awareness',
    },
    {
      key: 'labs',
      title: 'Virtual Labs & Simulation Modules',
      subtitle:'Bringing Real-World Experiments to Virtual Classrooms',
      description: `Enhancing STEM and engineering education with immersive, interactive, and curriculum-aligned 
XR experiences.Our virtual labs and simulations provide safe, repeatable, and cost-effective environments for hands-on learning.`,
      highlights: [
        'XR-based simulations for physics, chemistry, biology, and engineering concepts',
        'Custom modules aligned with institutional curriculum and learning objectives',
        'Interactive 3D environments for experimentation, observation, and evaluation',
        'Multi-user virtual labs for collaborative learning and remote access',
      ],
      image: '../images/XR practicalSkill_l.webp',
      alt: 'Virtual Labs',
    },
    {
      key: 'content',
      title: 'XR-Enabled Learning Content',
      subtitle:'Immersive Content that Transforms Learning Outcomes',
      description: `Deliver immersive, engaging, and concept-driven content across disciplines. We design XR modules that enhance comprehension, retention, and learner motivation through spatial storytelling and interactive experiences.`,
      highlights: [
        'Curriculum-aligned XR content for science, engineering, and vocational education',
        'Immersive 3D visualizations to simplify complex concepts',
        'Multi-sensory learning modules using AR/VR for deeper engagement',
        'Customizable content packs for K-12, higher education, and skill training',
      ],
      image: '../images/XR learning content_l.webp',
      alt: 'XRlearningContent',
    },
    {
      key: 'environments',
      title: 'Multi-User Learning Environments',
      subtitle:'Collaborative Classrooms Beyond Boundaries',
      description: `Enable real-time, collaborative learning experiences through shared XR spaces. These 
environments support peer-to-peer interaction, remote mentoring, and group-based exploration`,

      highlights: [
        'Shared XR classrooms for collaborative experiments',
        'Guided sessions with remote instructors using avatars or voice/chat',
        'Role-based simulations for medical, law, and management education',
        'Supports peer evaluation, data logging, and instructor dashboards',
      ],
      image: '../images/XR collaboration_l.webp ',
      alt: 'Collaborative XR Learning',
    },
    {
      key: 'innovation',
      title: 'Academic Innovation Labs',
      subtitle: 'Fueling Campus Innovation Through XR Exploration',
      description: `Foster next-generation research and prototyping with XR-ready labs designed for academic 
innovation. These labs empower faculty and students to explore spatial computing, conduct 
experiments, and build immersive applications.`,
      highlights: [
        'End-to-end setup of XR research and development spaces',
        'Support for interdisciplinary experimentation and prototyping',
        'Integration with Unity, Unreal, and sensor-based hardware systems',
        'Guidance for grant proposals, research publications, and tech ',
      ],
      image: '../images/XR spatial iinovation lab_l.webp',
      alt: 'Academic Innovation Labs',
    },
  ];

  return (
    <>
      <Navbar />
      <div className="xr-container">
        <p className="page-path">Services / For Academia</p>
        <p className="xr-intro">We support academic institutions in integrating XR into teaching, learning, and academic
innovation. From awareness workshops to XR-based labs and collaborative learning environments,
we bring the future of education to your campus.
</p>
        {sections.map((section, index) => (
          <React.Fragment key={section.key}>
            <div className={`xr-section ${index % 2 === 1 ? 'reverse' : ''}`}>
              <div className="xr-content">
                <h1 className="xr-title">{section.title}</h1>
                <p className="subtitle1">{section.subtitle}</p>
                <p className="description">
                  {section.description}
                  {section.extraText && (
                    <span
                      className="know-toggle"
                      onClick={() => toggleShowMore(section.key)}
                    >
                      {showMore[section.key] ? ' Know less' : ' Know more...'}
                    </span>
                  )}
                </p>
                {showMore[section.key] && section.extraText && (
                  <p className="extra-text">{section.extraText}</p>
                )}
                <div className="xr-highlights">
                  <h6>Highlights:</h6>
                  <ul>
                    {section.highlights.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="xr-image-wrapper">
                <img src={section.image} alt={section.alt} className="xr-image" />
              </div>
            </div>
            <hr className="xr-divider" />
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default ForAcademia;
